/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Copy_SuffixInputs */

const en_company_jobs_copy_suffix = /** @type {(inputs: Company_Jobs_Copy_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Copy)`)
};

const de_company_jobs_copy_suffix = /** @type {(inputs: Company_Jobs_Copy_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Kopie)`)
};

/**
* | output |
* | --- |
* | "(Copy)" |
*
* @param {Company_Jobs_Copy_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_copy_suffix = /** @type {((inputs?: Company_Jobs_Copy_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Copy_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_copy_suffix(inputs)
	return en_company_jobs_copy_suffix(inputs)
});